import axios from 'axios';
import { POST_START_HIGHWAY_LINE_API_URL, POST_END_HIGHWAY_LINE_API_URL, POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL,
  POST_CONNECTION_COMPONENTS_COUPLING_API_URL, POST_CONNECTION_COMPONENTS_FOB_API_URL, POST_CONNECTION_COMPONENTS_PON_BOX_API_URL,
  POST_PASSIVE_NODE_HID_ENTRANCE_API_URL} from '../OpticApiConfig';

// запись таблицу StartHighwayLine
export const WriteStartHighwayLine = async (id, selectedComponent, setSelectedComponent, inputId, setInputId,inputEntrance, setInputEntrance, showSnackbar, user, onClose) => {
    
    const token = localStorage.getItem('token');

    if(selectedComponent === '' || inputId === '') {
      showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
    } if(selectedComponent === 'House' && (inputEntrance === '' || inputId === '')) {
      showSnackbar('Пустой HouseId или № подъезда!', 'snackbarWarning');
    }else if(!token){
      showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
      if(selectedComponent == 'Well'){
        try {
            await axios.post(POST_START_HIGHWAY_LINE_API_URL, {           
                HighwayLineId: id,
                WellId: inputId,
                Type: "Well", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Закреплено!', 'snackbarWarning');
            onClose();
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
      }else if (selectedComponent == 'Pillar'){
        try {
          await axios.post(POST_START_HIGHWAY_LINE_API_URL, {           
              HighwayLineId: id,
              PillarId: inputId,
              Type: "Pillar", 
              AuthorId: user                        
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Закреплено!', 'snackbarWarning');
           onClose();
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }else if (selectedComponent == 'House'){
        try {
          await axios.post(POST_START_HIGHWAY_LINE_API_URL, {           
              HighwayLineId: id,
              HouseId: inputId,
              Type: "House", 
              Entrance: inputEntrance,
              AuthorId: user                        
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Закреплено!', 'snackbarWarning');
           onClose();
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }     
      else{
        showSnackbar('Ошибка при отправке!', 'snackbarWarning');
      }
      setSelectedComponent('');
      setInputId('');
      setInputEntrance('');
    }
  }

  // запись таблицу EndHighwayLine
export const WriteEndHighwayLine = async (id, selectedComponent, setSelectedComponent, inputId, setInputId,inputEntrance, setInputEntrance, showSnackbar,user, onClose) => {
  
    const token = localStorage.getItem('token');

    if(selectedComponent === '' || inputId === '') {
      showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
    } if(selectedComponent === 'House' && (inputEntrance === '' || inputId === '')) {
      showSnackbar('Пустой HouseId или № подъезда!', 'snackbarWarning');
    } else if(!token){
      showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    } else {
      if(selectedComponent == 'Well'){
        try {
            await axios.post(POST_END_HIGHWAY_LINE_API_URL, {           
                HighwayLineId: id,
                WellId: inputId,
                Type: "Well", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Закреплено!', 'snackbarWarning');
            onClose();
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
      }else if (selectedComponent == 'Pillar'){
        try {
          await axios.post(POST_END_HIGHWAY_LINE_API_URL, {           
              HighwayLineId: id,
              PillarId: inputId,
              Type: "Pillar", 
              AuthorId: user                        
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Закреплено!', 'snackbarWarning');
           onClose();
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }else if (selectedComponent == 'House'){
        try {
          await axios.post(POST_END_HIGHWAY_LINE_API_URL, {           
              HighwayLineId: id,
              HouseId: inputId,
              Type: "House", 
              Entrance: inputEntrance,
              AuthorId: user                        
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Закреплено!', 'snackbarWarning');
           onClose();
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }     
      else{
        showSnackbar('Ошибка при отправке!', 'snackbarWarning');
      }
      setSelectedComponent('');
      setInputId('');
      setInputEntrance('');
    }
  }

   // запись таблицу ConnectionComponents HighwayLine
export const WriteConnectionComponentsHighwayLine = async (id, selectedComponent, setSelectedComponent, inputId, setInputId,inputEntrance, setInputEntrance, showSnackbar, user) => {

      const token = localStorage.getItem('token');

      if(selectedComponent === '' || inputId === '') {
        showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
      } if(selectedComponent === 'House' && (inputEntrance === '' || inputId === '')) {
        showSnackbar('Пустой HouseId или № подъезда!', 'snackbarWarning');
      } else if(!token){
        showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
      } else {
        if(selectedComponent == 'Well'){
          try {
              await axios.post(POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL, {           
                  HighwayLineId: id,
                  WellId: inputId,
                  Type: "Well", 
                  AuthorId: user                        
              }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
              showSnackbar('Калодец закреплен!', 'snackbarWarning');
          } catch (error) {
            showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
          }
        }else if (selectedComponent == 'Pillar'){
          try {
            await axios.post(POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL, {           
                HighwayLineId: id,
                PillarId: inputId,
                Type: "Pillar", 
                AuthorId: user                       
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Опора закреплена!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
        }else if (selectedComponent == 'House'){
          try {
            await axios.post(POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL, {           
                HighwayLineId: id,
                HouseId: inputId,
                Type: "House", 
                Entrance: inputEntrance,
                AuthorId: user                       
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Дом закреплен!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
        }  
        else if (selectedComponent == 'Coupling'){
          try {
            await axios.post(POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL, {           
                HighwayLineId: id,
                CouplingLocationId: inputId,
                Type: "Coupling", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Муфта закреплена!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
        }  
        else if (selectedComponent == 'Fob'){
          try {
            await axios.post(POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL, {           
                HighwayLineId: id,
                FobLocationId: inputId,
                Type: "Fob", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Фоб закреплен!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
        } 
        else if (selectedComponent == 'PonBox'){
          try {           
            await axios.post(POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL, {           
                HighwayLineId: id,
                PonBoxLocationId: inputId,
                Type: "PonBox", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Пон-бокс закреплен!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
        }   
        else if (selectedComponent == 'Cassette'){
          try {           
            await axios.post(POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL, {           
                HighwayLineId: id,
                CassetteId: inputId,
                Type: "Cassette", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Кассета закреплена!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
        }   
        else if (selectedComponent == 'LineParent'){
          try {
            await axios.post(POST_CONNECTION_COMPONENTS_HIGHWAY_LINE_API_URL, {           
                HighwayLineId: id,
                LineParentId: inputId,
                Type: "LineParent", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Кабель закреплен!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
        }      
        else{
          showSnackbar('Ошибка при отправке!', 'snackbarWarning');
        }
        setSelectedComponent('');
        setInputId('');
        setInputEntrance('');
      }
  }

  // запись таблицу ConnectionComponents Coupling
export const WriteConnectionComponentsCoupling = async (id, selectedComponent, setSelectedComponent, inputId, setInputId,inputEntrance, setInputEntrance, showSnackbar, user) => {
   
    const token = localStorage.getItem('token');

    if(selectedComponent === '' || inputId === '') {
      showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
    } if(selectedComponent === 'House' && (inputEntrance === '' || inputId === '')) {
      showSnackbar('Пустой HouseId или № подъезда!', 'snackbarWarning');
    } else if(!token){
      showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    } else {
      if(selectedComponent == 'Well'){
        try {
            await axios.post(POST_CONNECTION_COMPONENTS_COUPLING_API_URL, {          
                CouplingLocationId: id,
                WellId: inputId,
                Type: "Well", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Калодец закреплен!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
      }else if (selectedComponent == 'Pillar'){
        try {
          await axios.post(POST_CONNECTION_COMPONENTS_COUPLING_API_URL, {           
              CouplingLocationId: id,
              PillarId: inputId,
              Type: "Pillar", 
              AuthorId: user                      
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Опора закреплена!', 'snackbarWarning');
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }else if (selectedComponent == 'House'){
        try {
          await axios.post(POST_CONNECTION_COMPONENTS_COUPLING_API_URL, {           
              CouplingLocationId: id,
              HouseId: inputId,
              Type: "House", 
              Entrance: inputEntrance,
              AuthorId: user                        
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Дом закреплен!', 'snackbarWarning');
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }        
      else{
        showSnackbar('Ошибка при отправке!', 'snackbarWarning');
      }
      setSelectedComponent('');
      setInputId('');
      setInputEntrance('');
    }
}

 // запись таблицу ConnectionComponents Fob
 export const WriteConnectionComponentsFob = async (id, selectedComponent, setSelectedComponent, inputId, setInputId,inputEntrance, setInputEntrance, showSnackbar, user) => {
 
  const token = localStorage.getItem('token');

  if(selectedComponent === '' || inputId === '') {
      showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
    } if(selectedComponent === 'House' && (inputEntrance === '' || inputId === '')) {
      showSnackbar('Пустой HouseId или № подъезда!', 'snackbarWarning');
    } else if(!token){
      showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    } else {
      if(selectedComponent == 'Well'){
        try {
            await axios.post(POST_CONNECTION_COMPONENTS_FOB_API_URL, {          
                FobLocationId: id,
                WellId: inputId,
                Type: "Well", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Калодец закреплен!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
      }else if (selectedComponent == 'Pillar'){
        try {
          await axios.post(POST_CONNECTION_COMPONENTS_FOB_API_URL, {           
              FobLocationId: id,
              PillarId: inputId,
              Type: "Pillar", 
              AuthorId: user                        
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Опора закреплена!', 'snackbarWarning');
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }else if (selectedComponent == 'House'){
        try {
          await axios.post(POST_CONNECTION_COMPONENTS_FOB_API_URL, {           
              FobLocationId: id,
              HouseId: inputId,
              Type: "House", 
              Entrance: inputEntrance,
              AuthorId: user                        
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Дом закреплен!', 'snackbarWarning');
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }        
      else{
        showSnackbar('Ошибка при отправке!', 'snackbarWarning');
      }
      setSelectedComponent('');
      setInputId('');
      setInputEntrance('');
    }
}

// запись таблицу ConnectionComponents Pon-Box
export const WriteConnectionComponentsPonBox = async (id, selectedComponent, setSelectedComponent, inputId, setInputId,inputEntrance, setInputEntrance, showSnackbar, user) => {
 
  const token = localStorage.getItem('token');

  if(selectedComponent === '' || inputId === '') {
      showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
    } if(selectedComponent === 'House' && (inputEntrance === '' || inputId === '')) {
      showSnackbar('Пустой HouseId или № подъезда!', 'snackbarWarning');
    } else if(!token){
      showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    } else {
      if(selectedComponent == 'Well'){
        try {
            await axios.post(POST_CONNECTION_COMPONENTS_PON_BOX_API_URL, {          
                PonBoxLocationId: id,
                WellId: inputId,
                Type: "Well", 
                AuthorId: user                        
            }, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
            showSnackbar('Калодец закреплен!', 'snackbarWarning');
        } catch (error) {
          showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
        }
      }else if (selectedComponent == 'Pillar'){
        try {
          await axios.post(POST_CONNECTION_COMPONENTS_PON_BOX_API_URL, {           
              PonBoxLocationId: id,
              PillarId: inputId,
              Type: "Pillar", 
              AuthorId: user                        
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Опора закреплена!', 'snackbarWarning');
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }else if (selectedComponent == 'House'){
        try {
          await axios.post(POST_CONNECTION_COMPONENTS_PON_BOX_API_URL, {           
              PonBoxLocationId: id,
              HouseId: inputId,
              Type: "House", 
              Entrance: inputEntrance,
              AuthorId: user                        
          }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
          showSnackbar('Дом закреплен!', 'snackbarWarning');
      } catch (error) {
        showSnackbar('Ошибка при отправке! Возможно запись уже существует!', 'snackbarWarning');
      }
      }        
      else{
        showSnackbar('Ошибка при отправке!', 'snackbarWarning');
      }
      setSelectedComponent('');
      setInputId('');
      setInputEntrance('');
    }
}


// Обновление Hid - Entrance в PassiveNode
export const UpdateHidEntrancePassiveNode = async (nodeId, hid, entrance, showSnackbar, handleClickSummit, user, handleCloseModal) => {

  const token = localStorage.getItem('token');
  if(!token) {
      showSnackbar('Ошибка! Токен не найден');
      return;
  }else {

      try {
        const response = await axios.patch(`${POST_PASSIVE_NODE_HID_ENTRANCE_API_URL}${nodeId}`,{ hid: hid, entrance: entrance, authorId: user }, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          }
        });

          if (response.status === 200) {
              showSnackbar('Закреплено!', 'snackbarWarning');
              handleClickSummit();
              handleCloseModal();
          } else if (response.status === 404) {
              showSnackbar('Ошибка!', 'snackbarWarning');
          } else {
              showSnackbar('Произошла ошибка сервера', 'snackbarWarning');
          }
      } catch (error) {
        showSnackbar('Ошибка при отправке запроса', 'snackbarWarning');
      }
  
  }
}

